<div class="control-panel-container">
  <header class="ptl-content-header control-panel__header">
    <div class="control-panel__header-text">
      <h1 class="control-panel__title">{{ 'translations.members.title' | transloco }}</h1>
      <p class="control-panel__subtitle">
        {{
          allMembersCount() ?? 0
            | i18nPlural
              : {
                  '=1': 'translations.global.label.oneUser' | transloco,
                  other:
                    'translations.global.label.countUsers'
                    | transloco
                      : {
                          count: allMembersCount() ?? 0,
                        },
                }
        }}
      </p>
    </div>

    <div class="ptl-content-header__actions control-panel__header-actions">
      @if (exportEnabled() && !isIframeMode) {
        @if (advancedExportAvailable) {
          <ptl-button
            type="secondary-neutral"
            size="sm"
            [icon]="LucideDownload"
            [iconSuffix]="LucideChevronDown"
            [text]="'translations.membersNew.controlPanel.export' | transloco"
            [matMenuTriggerFor]="exportMenu"
            [attr.aria-label]="'translations.global.ariaLabels.export' | transloco"
          ></ptl-button>
        } @else {
          <ptl-button
            type="secondary-neutral"
            size="sm"
            [icon]="LucideDownload"
            [text]="'translations.membersNew.controlPanel.export' | transloco"
            (clicked)="exportUsersButtonClicked()"
            [attr.aria-label]="'translations.global.ariaLabels.exportUsers' | transloco"
          ></ptl-button>
        }
      }

      @if (exportEnabled() && isIframeMode) {
        <ptl-button
          type="secondary-neutral"
          size="sm"
          [icon]="LucideDownload"
          [text]="'translations.membersNew.controlPanel.export' | transloco"
          (clicked)="exportUsersFilteredByGroup()"
          [attr.aria-label]="'translations.global.ariaLabels.exportUsers' | transloco"
        ></ptl-button>
      }

      @if (!isIframeMode && (isEvent() || isCardPage() || isPlaylistPage())) {
        <ptl-button
          type="secondary-neutral"
          size="sm"
          [icon]="LucideUpload"
          [text]="'translations.members.button.importCsv' | transloco"
          [disabled]="isImportDisabled"
          [matTooltip]="importDisabledTooltipText ?? ''"
          matTooltipClass="medium-tooltip"
          (clicked)="importUsersCsv()"
        ></ptl-button>
      }

      @if (!isIframeMode && isAdminScope && (canManageUserImportPrivileges$ | async)) {
        <ptl-button
          type="primary"
          size="sm"
          [icon]="LucidePlus"
          [text]="'translations.members.button.inviteMember' | transloco"
          (clicked)="onHeaderInviteMember()"
        ></ptl-button>
      }
    </div>
  </header>

  @if (showInviteMembers()) {
    <ptl-v3-invite-member (closed)="onQuickInviteClosed()" (invitationSent)="onQuickInviteSent()"></ptl-v3-invite-member>
  }

  @if (isEvent() || isCardPage() || isPlaylistPage()) {
    <div class="control-panel__description">
      <div class="description-remaining-tickets-box">
        @if (isEvent()) {
          <span class="body-s description">
            {{ 'translations.membersNew.controlPanel.pageDescriptionEvent' | transloco }}
          </span>
        }
        @if ((isCardPage() || isPlaylistPage()) && !isEvent()) {
          <div class="description">
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.first' | transloco }}
            </span>
            <span class="body-s bold">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.second' | transloco }}
            </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.third' | transloco }}
            </span>
            <span class="body-s bold">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.fourth' | transloco }}
            </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.fifth' | transloco }}
            </span>
            <span class="body-s bold">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.sixth' | transloco }}
            </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.seventh' | transloco }}
            </span>
          </div>
        }
        @if (limitedTickets) {
          <div class="remaining-tickets-count">
            <span class="body-s bold" [class]="remainingTicketsInfoClass"> {{ getRemainingTickets() }} / </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.ticketsLeft' | transloco: { ticketsQuantity: ticketsQuantity } }}
            </span>
          </div>
        }
      </div>
    </div>
  }

  <div class="members-toolbar">
    <mat-menu #exportMenu>
      <button mat-menu-item (click)="exportUsersButtonClicked()">
        <span class="body-s">{{ 'translations.members.button.exportCsv' | transloco }}</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="openAdvancedExport()">
        <span class="body-s">{{ 'translations.advancedExport.title.main' | transloco }}</span>
      </button>
    </mat-menu>

    <mat-menu #filterMenu>
      @for (label of filterLabels; track label.type) {
        <button mat-menu-item class="body-s" (click)="filterSelected(label.type)">{{ label.value }}</button>
      }
    </mat-menu>

    <div class="search-card">
      <div class="search-card__row">
        <ptl-sg-input
          class="search-card__input"
          [withIcon]="true"
          [icon]="LucideSearch"
          type="text"
          [formControl]="searchControl"
          [placeholder]="'translations.content.label.searchByName' | transloco"
        ></ptl-sg-input>

        <ptl-button
          [size]="'sm'"
          [type]="'secondary'"
          [icon]="LucideListFilter"
          [text]="'translations.global.button.filter' | transloco"
          [matMenuTriggerFor]="filterMenu"
        ></ptl-button>

        <span class="search-card__count">
          {{
            allMembersCount()
              | i18nPlural
                : {
                    '=1': 'translations.global.label.oneUser' | transloco,
                    other:
                      'translations.global.label.countUsers'
                      | transloco
                        : {
                            count: allMembersCount(),
                          },
                  }
          }}
        </span>
      </div>

      @if (filters?.length || newFilter) {
        <div class="filter-chips-list">
          @for (filter of filters; track filter.type) {
            <div class="filter-chip-wrapper">
              <ptl-base-badge
                [text]="filter.message"
                [color]="'blue'"
                [iconSuffix]="LucideX"
                [matTooltip]="filter.message"
                (clicked)="filterSelected(filter.type)"
                (iconClick)="onRemoveFilter(filter.type)"
              ></ptl-base-badge>
              @if (currentFilter === filter.type) {
                @switch (filter.type) {
                  @case ('REVIEW_STATUS') {
                    <ptl-review-status-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('REVIEW_STATUS')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                    ></ptl-review-status-filter>
                  }
                  @case ('GROUP') {
                    <ptl-group-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('GROUP')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                      [playlistUid]="!isAdminPage() ? playlistUid() : undefined"
                    ></ptl-group-filter>
                  }
                  @case ('ROLE') {
                    <ptl-role-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('ROLE')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                    ></ptl-role-filter>
                  }
                  @case ('ATTENDANCE') {
                    <ptl-attendance-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('ATTENDANCE')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                      [isPlaylistPageAndTicketExist]="isPlaylistPage() && isTicketExist"
                    ></ptl-attendance-filter>
                  }
                  @case ('ACTIVITY') {
                    <ptl-activity-date-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('ACTIVITY')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                    ></ptl-activity-date-filter>
                  }
                  @case ('COMPLETION') {
                    <ptl-completion-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('COMPLETION')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                      [isPlaylistPage]="isPlaylistPage()"
                      [playlistUid]="playlistUid()"
                      [isCardPage]="isCardPage()"
                      [cardUid]="cardUid()"
                      [cardHeaders]="cardHeaders()"
                      [formHeaders]="formHeaders()"
                    ></ptl-completion-filter>
                  }
                }
              }
            </div>
          }

          @if (newFilter) {
            <div class="filter-chip-wrapper">
              @switch (newFilter) {
                @case ('GROUP') {
                  @if (!isIframeMode) {
                    <ptl-group-filter
                      class="filter-panel"
                      (filterDeleted)="onRemoveFilter('GROUP')"
                      (filterSaved)="onSaveFilter($event)"
                      [selectedFilters]="filters"
                      [playlistUid]="!isAdminPage() ? playlistUid() : undefined"
                    ></ptl-group-filter>
                  }
                }
                @case ('ROLE') {
                  <ptl-role-filter
                    class="filter-panel"
                    (filterDeleted)="onRemoveFilter('ROLE')"
                    (filterSaved)="onSaveFilter($event)"
                    [selectedFilters]="filters"
                  ></ptl-role-filter>
                }
                @case ('ATTENDANCE') {
                  <ptl-attendance-filter
                    class="filter-panel"
                    (filterDeleted)="onRemoveFilter('ATTENDANCE')"
                    (filterSaved)="onSaveFilter($event)"
                    [selectedFilters]="filters"
                    [isPlaylistPageAndTicketExist]="isPlaylistPage() && isTicketExist"
                  ></ptl-attendance-filter>
                }
                @case ('ACTIVITY') {
                  <ptl-activity-date-filter
                    class="filter-panel"
                    (filterDeleted)="onRemoveFilter('ACTIVITY')"
                    (filterSaved)="onSaveFilter($event)"
                    [selectedFilters]="filters"
                  ></ptl-activity-date-filter>
                }
                @case ('COMPLETION') {
                  <ptl-completion-filter
                    class="filter-panel"
                    (filterDeleted)="onRemoveFilter('COMPLETION')"
                    (filterSaved)="onSaveFilter($event)"
                    [selectedFilters]="filters"
                    [isPlaylistPage]="isPlaylistPage()"
                    [playlistUid]="playlistUid()"
                    [isCardPage]="isCardPage()"
                    [cardUid]="cardUid()"
                    [cardHeaders]="cardHeaders()"
                    [formHeaders]="formHeaders()"
                  ></ptl-completion-filter>
                }
                @case ('REVIEW_STATUS') {
                  <ptl-review-status-filter
                    class="filter-panel"
                    (filterDeleted)="onRemoveFilter('REVIEW_STATUS')"
                    (filterSaved)="onSaveFilter($event)"
                    [submissionMode]="getSubmissionMode"
                    [selectedFilters]="filters"
                  ></ptl-review-status-filter>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
